import styled, { css } from "styled-components";
import background from "../assets/tlo.jpg";
import download from "../assets/download.svg";
import email from "../assets/email.svg";
import pl from "../assets/pl.png";
import en from "../assets/en.png";

export const Container = styled.div`
  position: relative;
  width: 80%;
  margin: 0 auto;
  text-align: center;
  img {
    position: absolute;
    max-width: 100%;
    left: 0;
    top: 0;
  }
  @media (max-width: 768px) {
    height: 250px;
    margin-top: 48px;
  }
`;

export const Picker = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  bottom: 0;
  > span {
    display: inline-block;
    font-weight: bold;
    margin-right: 12px;
  }
`;

export const Flex = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  margin: 18px 0;
  flex-wrap: wrap;
  .circle-picker {
    flex-basis: 100%;
    margin: 18px 0;
  }
`;

export const Buttons = styled.div`
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  button {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    color: #fff;
    border: none;
    padding: 12px 0;
    cursor: pointer;
    transition: 0.5s;
    background-size: 20px;
    background-repeat: no-repeat;
    background-color: #272727;
    background-position: 10px;
    &:first-child {
      background-image: url(${download});
    }
    &:nth-child(2) {
      background-image: url(${email});
    }
    &:hover {
      opacity: 0.5;
    }
    @media (max-width: 768px) {
      font-size: 10px;
    }
  }
`;

export const Fieldset = styled.div`
  display: grid;
  grid-row-gap: 15px;
  position: relative;
  h2 {
    margin: 0;
  }
  > div > span {
    display: inline-block;
    font-weight: bold;
  }
`;

export const FieldGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;
`;

export const Background = styled.div`
  background-image: url(${background});
  background-size: cover;
  height: 100%;
  @media (max-height: 550px) {
    height: auto;
  }
  ${props =>
    props.transparent &&
    css`
      @media (max-width: 768px) {
        height: auto;
      }
      // &:after {
      //   content: "";
      //   width: 100%;
      //   height: 100%;
      //   position: fixed;
      //   background-color: rgba(255, 255, 255, 0.5);
      //   top: 0;
      //   left: 0;
      // }
    `};
`;

export const Wrapper = styled.div`
  position: relative;
  z-index: 100;
`;

export const Button = styled.button`
  width: 400px;
  font-size: 24px;
`;

export const FieldName = styled.span`
  font-weight: bold;
  margin-right: 12px;
  min-width: 140px;
  display: inline-block;
`;

export const LanguageSwitcher = styled.div`
  display: flex;
  z-index: 999;
  position: fixed;
  right: 10px;
  top: 10px;
  button {
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent;
    background-size: contain;
    text-indent: -9999px;
    width: 24px;
    height: 24px;
    border: none;
    margin: 0 4px;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      opacity: 0.8;
    }
  }
  .pl {
    background-image: url(${pl});
  }
  .en {
    background-image: url(${en});
  }
`;
